import { render } from "./RollUserBetsElement.vue?vue&type=template&id=354a9ff2&scoped=true"
import script from "./RollUserBetsElement.vue?vue&type=script&lang=js"
export * from "./RollUserBetsElement.vue?vue&type=script&lang=js"

import "./RollUserBetsElement.vue?vue&type=style&index=0&id=354a9ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354a9ff2"]])

export default __exports__